export var DateLibrary;
(function (DateLibrary) {
    DateLibrary["DayJs"] = "dayjs";
    DateLibrary["Moment"] = "moment";
})(DateLibrary || (DateLibrary = {}));
